// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"228":"a4e2fd69","586":"fefd8069","723":"f25c722a","730":"28ac32e9"}[chunkId] + ".css";
};